import 'core-js/shim';
import { Component, OnInit, NgZone, OnDestroy, AfterViewInit } from '@angular/core';
import { ApiService, ConstantService, HelperService } from '@app/core';

import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import * as moment from 'moment';

@Component({
  selector: 'app-sales-chart',
  templateUrl: './sales-chart.component.html',
})
export class SalesChartComponent implements OnInit, AfterViewInit, OnDestroy {

  private chart: am4charts.PieChart;

  totalSalesCountCurrentMonth = 0;
  totalSalesCash = 0;
  totalSalesFinance = 0;
  totalSalesOutsideFinance = 0;
  cash_deal_goal = 0;
  in_house_deal_goal = 0;
  outside_deal_goal = 0;
  param = [];

  currentMonth: string;
  currentYear: string;
  years: any = [];
  months: any = [];
  filterOptions = {
    month: '',
    year: ''
  };
  constructor(
    private apiSvc: ApiService,
    private constantSvc: ConstantService,
    private helperSvc: HelperService,
    private zone: NgZone
  ) { }

  ngOnInit() {
    this.years = this.helperSvc.getYears();
    this.months = this.helperSvc.getMonths();
    this.currentYear = (moment().year().toString());
    this.currentMonth = ('0' + (moment().month() + 1)).slice(-2).toString();
    this.filterOptions.year = this.currentYear;
    this.filterOptions.month = this.currentMonth;
  }
  ngAfterViewInit() {
    this.countAllCurrentMonthSales();
    this.countAllCurrentMonthFinanceSales();
    this.countAllCurrentMonthCashSales();
    this.countAllCurrentMonthOutsideFinanceSales();
    this.initSalesChart();
    this.getSalesGoal();
  }

  countAllCurrentMonthSales(): void {
    this.param = [];
    this.apiSvc.getService(this.constantSvc.APIConfig.COUNTSALES, '?month=' + this.filterOptions.month + '&year=' + this.filterOptions.year).subscribe(
      data => {
        if (data.Status === 200) {
          this.totalSalesCountCurrentMonth = data.Data[0].dealCount;
          this.initSalesChart();
        }
      }, error => console.log('Problem in count all current month sales in dashboard')
    );
  }

  countAllCurrentMonthFinanceSales() {
    this.apiSvc.getService(this.constantSvc.APIConfig.COUNTSALES, '?month=' + this.filterOptions.month + '&year=' + this.filterOptions.year + '&saleType=I').subscribe(
      data => {
        this.totalSalesFinance = data.Data[0].dealCount;
        this.initSalesChart();
      }, error => console.log('problem in count all current month sales')
    );
  }

  countAllCurrentMonthCashSales() {
    this.apiSvc.getService(this.constantSvc.APIConfig.COUNTSALES, '?month=' + this.filterOptions.month + '&year=' + this.filterOptions.year + '&saleType=C').subscribe(
      data => {
        this.totalSalesCash = data.Data[0].dealCount;
        this.initSalesChart();
      }, error => console.log('problem in count all current month sales')
    );
  }

  countAllCurrentMonthOutsideFinanceSales() {
    this.apiSvc.getService(this.constantSvc.APIConfig.COUNTSALES, '?month=' + this.filterOptions.month + '&year=' + this.filterOptions.year + '&saleType=O').subscribe(
      data => {
        this.totalSalesOutsideFinance = data.Data[0].dealCount;
        this.initSalesChart();
      }, error => console.log('problem in count all current month sales')
    );
  }

  getSalesGoal(): void {
    this.apiSvc.getService(this.constantSvc.APIConfig.GETSETTINGS, this.param).subscribe(
      data => {
        this.cash_deal_goal = data.data[26].meta_value;
        this.in_house_deal_goal = data.data[27].meta_value;
        this.outside_deal_goal = data.data[28].meta_value;
      }, error => console.log('error occurred!')
    );
  }

  applyFilter() {
    this.countAllCurrentMonthSales();
    this.countAllCurrentMonthFinanceSales();
    this.countAllCurrentMonthCashSales();
    this.countAllCurrentMonthOutsideFinanceSales();
  }

  initSalesChart() {
    this.zone.runOutsideAngular(() => {
      // Create chart instance
      const chart = am4core.create('salesChartDiv', am4charts.XYChart);
      chart.height = 200;
      // Add data
      chart.data = [{
        'type': 'Cash',
        'sales': this.totalSalesCash
      }, {
        'type': 'In-House',
        'sales': this.totalSalesFinance
      }, {
        'type': 'Outside Finance',
        'sales': this.totalSalesOutsideFinance
      }];

      // Create axes
      const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = 'type';
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 30;

      const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

      // Create series
      const series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueY = 'sales';
      series.dataFields.categoryX = 'type';
      series.name = 'sales';
      series.columns.template.tooltipText = '{categoryX}: [bold]{valueY}[/]';
      series.columns.template.fillOpacity = .8;

      const columnTemplate = series.columns.template;
      columnTemplate.strokeWidth = 2;
      columnTemplate.strokeOpacity = 1;

    });
  }

  ngOnDestroy() {
    this.zone.runOutsideAngular(() => {
      if (this.chart) {
        this.chart.dispose();
      }
    });
  }

}
